import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

import { CONSTITUENCY_CONFIG_URL } from "../../../../api/api_routing_urls";
import { SUBDIVISION_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import Dashboard from "../../../../common/Dashboard";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import AddSubDivisionForm from "./AddSubDivisionForm";
import SubDivisionList from "./SubDivisionList";

const SubDivisionConfig = () => {
  const { auth } = useAuth();

  const [subDivisionList, setSubDivisionList] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editSubDivisionDetails, setEditSubDivisionDetails] = useState({});
  const isEdit = Object.keys(editSubDivisionDetails).length > 0 ? true : false;
  const controller = new AbortController();
  const getSubDivisionList = async () => {
    try {
      const response = await axiosPrivate.get(SUBDIVISION_CONFIG_URL, {
        signal: controller.signal,
      });
      response.status === 200 &&
        setSubDivisionList(response.data.subDivisionList);
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    getSubDivisionList();
    setEditSubDivisionDetails({});
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);
  return (
    <Dashboard sidebarType={auth.rolename}>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Sub Division"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${isEdit ? "Update SubDivision" : "Add SubDivision"}`}
        isAdd={true}
      >
        <AddSubDivisionForm
          getSubDivisionList={getSubDivisionList}
          editSubDivisionDetails={editSubDivisionDetails}
          setEditSubDivisionDetails={setEditSubDivisionDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <SubDivisionList
          subDivisionList={subDivisionList}
          setEditSubDivisionDetails={setEditSubDivisionDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default SubDivisionConfig;
